"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GlSectionDivider = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var theme_1 = require("./theme");
exports.GlSectionDivider = (0, react_1.memo)(function (props) {
    var className = props.className;
    var _a = useStyles(), classes = _a.classes, cx = _a.cx;
    return ((0, jsx_runtime_1.jsx)("div", __assign({ className: cx(classes.root, className) }, { children: (0, jsx_runtime_1.jsx)("div", { className: cx(classes.inner) }) })));
});
var useStyles = (0, theme_1.makeStyles)({ "name": { GlSectionDivider: exports.GlSectionDivider } })(function (theme) { return ({
    "root": __assign({ "display": "flex", "justifyContent": "center" }, theme.spacing.topBottom("padding", "".concat(theme.spacing(7), "px"))),
    "inner": {
        "backgroundColor": theme.colors.useCases.typography.textTertiary,
        "height": 1,
        "width": "60%",
    },
}); });
//# sourceMappingURL=GlSectionDivider.js.map